module EEX.McEc.Controls.CertificateDialog {

    import UserInfo = AppKitchen.Api.Models.UserInfo;

    // ReSharper disable once InconsistentNaming
    export interface CertificateAttributes {
        commonName: string,
        countryName?: string,
        stateName?: string,
        localityName?: string,
        organizationName?: string,
        organizationalUnitName?: string,
    }

    // ReSharper disable once InconsistentNaming
    export interface CertificateDialogModelAttribute extends AppKitchen.ModelBaseAttributes {
        userInfo?: UserInfo,
        certificateKey?: number,
        store?: Pki.Store,
        certificateFile?: string,
        privateKeyPassword?: string;
        pkcsPassword?: string,
        currentProcessStep?: number,
        totalProcessSteps?: number,
        certificateAttributes?: CertificateAttributes,
        isServerCertificate?: boolean;
    }

    export class CertificateDialogModel extends AppKitchen.ModelBase<CertificateDialogModelAttribute> {

        constructor(attributes: CertificateDialogModelAttribute) {
            super(attributes);
        }

    }
}